export default __webpack_public_path__ + "static/media/003-advice.50bf61c7.svg";